
/**
 *重命名组件
 * created by yxy
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Checkbox, Modal, Input, InputNumber} from 'antd';
import BaseComponent from "../../../base/BaseComponent";
import {message} from './Mess'
import {Scrollbars} from "react-custom-scrollbars";
import CmForm from "../../../components/CmForm/CmForm";
const { Search } = Input;


export default class StorageSpace  extends BaseComponent {
    static defaultProps = {
    };
    static propTypes = {
    };

    constructor(props) {
        super(props);
        this.state = {
            visible:false,
            storeNumber:''
        }
    }

    componentWillMount() {
    }
    componentDidMount() {
    }

    render() {
        let left =  this.props.marginLeft?this.props.marginLeft: 5;
      
        return(
            <div >
                <div  style={{marginLeft:left,cursor:'pointer'}} onClick={() => this.CreatePersonal()}>
                    {this.props.text?<span >设置储存空间</span>: <Button icon={"folder"}  type='primary'>设置储存空间</Button>}
                </div>

                <Modal
                    maskClosable={false}
                    keyboard={true}
                    title="设置储存空间"
                    visible={this.state.visible}
                    centered
                    width={400}
                    okText={'保存'}
                    onOk={()=>{
                        this.saveData()
                    }}
                    onCancel={()=>{this.setState({visible:false})}}>
                    <CmForm onSubmit={() => {
                        this.saveData()
                    }}>
                    <div>

                            <span style={{color:'red'}}>*</span>
                            <span style={{marginLeft:5}}>存储空间上限(GB)：</span>
                            <InputNumber placeholder="请输入存储空间"
                                         style={{width: 200, marginLeft: '12px'}}  min={0}   value={this.state.storeNumber}
                                     onChange={(value) => {
                                       this.setState({storeNumber: value})
                                   }}/>
                    </div>
                    </CmForm>
                </Modal>
            </div>
        )
    }

    CreatePersonal(){
        if(this.props.checkArray.length){
            console.log(this.props.checkArray,'checkArray')
            if(this.props.text){
               this.state.storeNumber = this.props.checkArray[0].extendedAttributeJson&&this.props.checkArray[0].extendedAttributeJson.availableSize?this.props.checkArray[0].extendedAttributeJson.availableSize:0
            }else{
                this.state.storeNumber = ''
            }
            this.state.visible = true;
            this.setState({})
        }else{
            message.error('至少选择一个文件夹或者文件！')
        }

    }
    saveData(){
        let array = [];
        this.props.checkArray&&this.props.checkArray.length&&this.props.checkArray.forEach((item,index)=>{
            array.push({
                virtualFileId:item.id,
                availableSize:this.state.storeNumber,
                occupationSize:item.extendedAttributeJson&&item.extendedAttributeJson.occupationSize?item.extendedAttributeJson.occupationSize:0
            })
        });
        this.request({
            url: '/cm-sites-storage-management/zykManagement/updateAvailableSizeList',
            method: "post",
            body: array,
            contentType:'json',
            callBack: (data) => {
                if (data) {
                    message.success('设置成功')
                     this.setState({visible:false},()=>{
                         this.props.callBack&& this.props.callBack()
                     })
                }
            }
        });
    }

}
